<ng-container *ngIf="{ enableMagicLinkExperience: enableMagicLinkExperience$ | async } as cfg">
  <div class="pt-6">
    <aiwyn-logo [height]="60"></aiwyn-logo>
  </div>

  <div class="content-container">
    <div class="authentication-body">
      <ng-container *ngIf="!cfg.enableMagicLinkExperience; else newTitle">
        <button
          andButton
          color="ghost"
          (click)="goBack()"
        >
          <aiwyn-icon name="arrow-left" class="me-1"></aiwyn-icon>
          Go back
        </button>

        <h2>Reset your password</h2>
      </ng-container>

      <ng-template #newTitle>
        <h2>Sign in without a password</h2>
      </ng-template>

      <form [formGroup]="resetPasswordForm" name="resetPasswordForm" novalidate class="w-100">
        <div class="position-relative w-100">
          <label *ngIf="cfg.enableMagicLinkExperience" class="body-400 color-gray-300 ta--left">Email address</label>

          <div class="input-div mt-2">
            <input
              formControlName="email"
              type="email"
              name="passwordResetEmail"
              [placeholder]="cfg.enableMagicLinkExperience ? '' : 'Email address to reset password *'"
              autocomplete="username"
              class="form-input pe-8"
              [ngClass]="{ 'form-input--invalid': (resetPasswordForm.controls.email.errors && canShowValidationErrors(resetPasswordForm.controls.email)) || userEmailError() }"
            />

            <div class="form-control__post-icon">
              <aiwyn-icon name="envelope"></aiwyn-icon>
            </div>
          </div>
        </div>

        <mat-error *ngIf="(resetPasswordForm.controls.email.errors && canShowValidationErrors(resetPasswordForm.controls.email)) || !this.lockedEmailIsValid || userEmailError()">
          A valid email is required
        </mat-error>

        <ng-container *ngIf="cfg.enableMagicLinkExperience">
          <button
            andButton
            color="primary"
            size="large"
            class="mt-6 w-100"
            [isLoading]="isSignInProcessing$ | async"
            (click)="signInWithEmailLink()"
          >
            Request a magic sign-in link
          </button>

          <p class="body-300 color-gray-100 mt-4">
            We'll email you a link. Just click to sign in.
          </p>

          <p class="body-300 color-gray-100">
            No password needed!
          </p>

          <div class="hr-spacer login__hr"><span>OR</span></div>
        </ng-container>

        <button
          id="resetPasswordButton"
          type="submit"
          andButton
          [color]="cfg.enableMagicLinkExperience ? 'secondary' : 'primary'"
          size="large"
          [isLoading]="isSubmissionProcessing$ | async"
          class="w-100 mt-6"
          (click)="submit()"
        >
          {{ cfg.enableMagicLinkExperience ? "Create a new password" : "Send reset link" }}
        </button>

        <p *ngIf="cfg.enableMagicLinkExperience" class="body-300 color-gray-100 mt-4">
          We’ll email you a link to create a new password.
        </p>
      </form>
    </div>

    <div *ngIf="cfg.enableMagicLinkExperience" class="body-400 mt-6">
      <p class="color-gray-100 text-center mb-1">
        Want to pay a bill without signing in?
      </p>

      <div *ngIf="showGuestLogin()" class="d-flex justify-content-center">
        <button
          andButton
          color="hyperlink"
          class="p-0 fw-light"
          (click)="getClientKeyForAnonymousUser()"
          data-cy="guest-login"
        >
          {{ "Go to guest checkout" }}
        </button>
      </div>
    </div>

    <ng-container *ngIf="cfg.enableMagicLinkExperience">
      <app-full-client-portal-footer class="mt-6"></app-full-client-portal-footer>
    </ng-container>
  </div>

  <ng-container *ngIf="!cfg.enableMagicLinkExperience">
    <app-full-client-portal-footer class="mt-6"></app-full-client-portal-footer>
  </ng-container>
</ng-container>
